module.exports = __webpack_public_path__ + "img/menucn-5-8.45643c89.svg";